const UserStatus = {
    REGISTERED: 'REGISTERED',
    UNREGISTERED: 'UNREGISTERED',
    PENDING: 'PENDING',
    SUSPENDED: 'SUSPENDED',
    PAUSED: 'PAUSED',
    UNKNOWN: 'UNKNOWN'
}

const UserRole = {
    ADMIN: 'ADMIN',
    USER: 'USER'
}

const UserOnlineStatus = {
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE'
}

export { UserStatus, UserRole, UserOnlineStatus };